module.exports = __webpack_public_path__ + "img/mifeng.2a9311e2.png";